/** модальное окно для выбора локализаций в требуемых случаях */
import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import IntlMessages from "util/intlMessages";
import { adminAPI } from "redux/api";
import { FloatModal } from "components/special";

const { api } = adminAPI.actions;

const FloatSpecialsCategoriesModal = (props) => {
  return (
    <FloatModal
      header={<IntlMessages id="Specials.Categories" />}
      {...props}
      head={(search, searchQuery, setSearchQuery) => {
        return (
          <>
            <th>
              <IntlMessages id="name" />
            </th>
            <th style={{ width: "30px" }}></th>
          </>
        );
      }}
      row={(category, clickHandler) => (
        <>
          <td onClick={clickHandler} className={!category.enabled ? "text-strike" : ""}>
            {category.name}
          </td>
          <td></td>
        </>
      )}
    />
  );
};

const FloatSpecialsCategories = (props) => {
  return <FloatSpecialsCategoriesModal {...props} />;
};
export default connect(null, {
  getData: api.get("/api/references/specials_categories"),
})(FloatSpecialsCategories);
